import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Group } from '@libs/src/models/group.model';

const inviteCodeAPIURL = `/api/v3/invite-code`;

@Injectable({ providedIn: 'root' })
export class InviteCodesBackend {
  constructor(private http: HttpClient) {}

  getInviteCode(inviteCode: string) {
    return this.http.get(`${inviteCodeAPIURL}/${inviteCode}`);
  }

  getGroupInviteCode(group: Group) {
    return this.http.get(`${inviteCodeAPIURL}/groups/${group._id}`);
  }

  postGroupInviteCode(group: Group) {
    return this.http.post(`${inviteCodeAPIURL}/groups/${group._id}`, {});
  }
}
